import React from 'react';

import TextArea, { BaseTextAreaProps } from '../Base/TextArea';
import InputError from '../InputError';
import InputLabel from '../InputLabel';
import { FieldProps } from './FieldProps';

export type TextAreaFieldProps = FieldProps<BaseTextAreaProps>;

const TextAreaField = ({
  block = false,
  disabled = false,
  error = false,
  errorMessage,
  label,
  required,
  ...props
}: TextAreaFieldProps) => {
  const common = { required, disabled, block, error };

  return (
    <InputLabel label={label} {...common}>
      <TextArea {...common} {...props} />
      <InputError>{error ? errorMessage : ''}</InputError>
    </InputLabel>
  );
};

export default TextAreaField;
